<template>
  <m-dialog ref="dlg" @save="save" :title="kelas && kelas.id ? 'Ubah Kelas' : 'Tambah Kelas'">
    <v-row row wrap justify="center" align="center" v-if="kelas">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pa-5 mb-5">
            <v-row class="mx-2 pt-3">
              <v-col cols="12" class="px-5">
                <m-alert show :title="alert.kelas.form.judul" :info="alert.kelas.form.deskripsi" closable></m-alert>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row wrap class="mx-2">
                <v-col cols="12" class="my-0">
                  <v-text-field
                    outlined
                    dense
                    autocomplete="false"
                    name="Nama"
                    placeholder="Isikan Nama"
                    label="Nama Kelas"
                    v-model="kelas.nama"
                    persistent-hint
                    data-vv-name="nama"
                    data-vv-as="Nama"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.nama')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="my-0 py-0">
                  <v-textarea
                    outlined
                    autocomplete="false"
                    name="Deskripsi"
                    placeholder="Isikan Deskripsi"
                    label="Deskripsi Kelas"
                    v-model="kelas.keterangan"
                    persistent-hint
                    data-vv-name="keterangan"
                    data-vv-as="Deskripsi"
                    v-validate="''"
                    :error-messages="errors.collect('form.keterangan')"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6" class="my-0 py-0">
                  <v-autocomplete
                    outlined
                    dense
                    autocomplete="off"
                    v-model="kelas.moda"
                    :items="itemModas"
                    no-data-text="Data Tidak Tersedia"
                    placeholder="Pilih Moda"
                    label="Untuk Moda"
                    name="Moda"
                    item-value="id"
                    item-text="keterangan"
                    return-object
                    data-vv-name="moda"
                    data-vv-as="Moda"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.moda')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="my-0 py-0" v-if="diklat && diklat.is_mapel == 1 && false">
                  <v-autocomplete
                    outlined
                    dense
                    autocomplete="off"
                    v-model="kelas.jenjang"
                    :items="itemJenjangs"
                    no-data-text="Data Tidak Tersedia"
                    placeholder="Pilih Jenjang"
                    label="Untuk Jenjang"
                    name="Jenjang"
                    @change="loadMapel(kelas.jenjang.id)"
                    item-value="id"
                    item-text="keterangan"
                    return-object
                    data-vv-name="jenjang"
                    data-vv-as="Jenjang"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.jenjang')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="my-0 py-0">
                  <v-autocomplete
                    :disabled="diklat && diklat.is_mapel == 1 && !kelas.jenjang ? false : false"
                    outlined
                    dense
                    autocomplete="off"
                    v-model="kelas.mapel"
                    :items="itemMapels"
                    no-data-text="Data Tidak Tersedia"
                    placeholder="Pilih Mata Pelajaran"
                    label="Untuk Mata Pelajaran"
                    name="Mata Pelajaran"
                    item-value="id"
                    item-text="keterangan"
                    return-object
                    data-vv-name="kelas"
                    data-vv-as="Mata Pelajaran"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.kelas')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" lg="6" class="my-0 py-0">
                  <span>Tanggal Mulai</span>
                  <datetime
                    type="datetime"
                    value-zone="Asia/Jakarta"
                    zone="Asia/Jakarta"
                    :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
                    :phrases="{ ok: 'Lanjut', cancel: 'Batal' }"
                    v-model="kelas.tanggal_mulai"
                    class="timepicker"
                  ></datetime>
                </v-col>
                <v-col cols="12" md="6" lg="6" class="my-0 py-0">
                  <span>Tanggal Selesai</span>
                  <datetime
                    type="datetime"
                    value-zone="Asia/Jakarta"
                    zone="Asia/Jakarta"
                    :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' }"
                    :phrases="{ ok: 'Lanjut', cancel: 'Batal' }"
                    v-model="kelas.tanggal_selesai"
                    class="timepicker"
                  ></datetime>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mt-5">
                  <span class="title primary--text">Maksimal Pengguna</span>
                  <br />
                  <v-row>
                    <v-col cols="12" md="6" lg="6" xl="6" v-for="peran in filterPeran(konfigPeran)" :key="peran.index">
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        autocomplete="false"
                        :name="`Jumlah Maksimal ` + peran.label"
                        :label="`Jumlah Maksimal ` + peran.label"
                        v-model="kelas[peran.max_attribute]"
                        persistent-hint
                        :data-vv-name="peran.max_attribute"
                        :data-vv-as="`Jumlah Maksimal ` + peran.label"
                        v-validate="'required|numeric'"
                        :error-messages="errors.collect('form.' + peran.max_attribute)"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        autocomplete="false"
                        name="Jumlah Maksimal Instruktur"
                        placeholder="Isikan Jumlah Maksimal Instruktur"
                        label="Jumlah Maksimal Instruktur"
                        v-model="kelas.max_instruktur"
                        persistent-hint
                        data-vv-name="max_instruktur"
                        data-vv-as="Jumlah Maksimal Instruktur"
                        v-validate="'required|numeric'"
                        :error-messages="errors.collect('form.max_instruktur')"
                      ></v-text-field>
                    </v-col> -->
                    <!--                    <v-col cols="6" sm="6" md="6" lg="6" xl="6">-->
                    <!--                      <v-text-field-->
                    <!--                        outlined-->
                    <!--                        dense-->
                    <!--                        type="number"-->
                    <!--                        autocomplete="false"-->
                    <!--                        name="Jumlah Maksimal Instruktur (Data dari NS)"-->
                    <!--                        placeholder="Isikan Jumlah Maksimal Instruktur (Data dari NS)"-->
                    <!--                        label="Jumlah Maksimal Instruktur (Data dari NS)"-->
                    <!--                        v-model="kelas.max_narasumber"-->
                    <!--                        persistent-hint-->
                    <!--                        data-vv-name="max_narasumber"-->
                    <!--                        data-vv-as="Jumlah Maksimal Instruktur (Data dari NS)"-->
                    <!--                        v-validate="'required|numeric'"-->
                    <!--                        :error-messages="errors.collect('form.max_narasumber')"-->
                    <!--                      ></v-text-field>-->
                    <!--                    </v-col>-->

                    <!-- <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        autocomplete="false"
                        name="Jumlah Maksimal Fasilitator"
                        placeholder="Isikan Jumlah Maksimal Fasilitator"
                        label="Jumlah Maksimal Fasilitator"
                        v-model="kelas.max_fasilitator"
                        persistent-hint
                        data-vv-name="max_gp"
                        data-vv-as="Jumlah Maksimal Fasilitator"
                        v-validate="'required|numeric'"
                        :error-messages="errors.collect('form.max_gp')"
                      ></v-text-field>
                    </v-col> -->
                    <!--                    <v-col cols="6" sm="6" md="6" lg="6" xl="6">-->
                    <!--                      <v-text-field-->
                    <!--                        outlined-->
                    <!--                        dense-->
                    <!--                        type="number"-->
                    <!--                        autocomplete="false"-->
                    <!--                        name="Jumlah Maksimal Pendamping"-->
                    <!--                        placeholder="Isikan Jumlah Maksimal Pendamping"-->
                    <!--                        label="Jumlah Maksimal Pendamping"-->
                    <!--                        v-model="kelas.max_pendamping"-->
                    <!--                        persistent-hint-->
                    <!--                        data-vv-name="max_dosen"-->
                    <!--                        data-vv-as="Jumlah Maksimal Pendamping"-->
                    <!--                        v-validate="'required|numeric'"-->
                    <!--                        :error-messages="errors.collect('form.max_dosen')"-->
                    <!--                      ></v-text-field>-->
                    <!--                    </v-col>-->

                    <!--                    <v-col cols="6" sm="6" md="6" lg="6" xl="6">-->
                    <!--                      <v-text-field-->
                    <!--                        outlined-->
                    <!--                        dense-->
                    <!--                        type="number"-->
                    <!--                        autocomplete="false"-->
                    <!--                        name="Jumlah Maksimal Admin LMS"-->
                    <!--                        placeholder="Isikan Jumlah Maksimal Admin LMS"-->
                    <!--                        label="Jumlah Maksimal Admin LMS"-->
                    <!--                        v-model="kelas.max_adminlms"-->
                    <!--                        persistent-hint-->
                    <!--                        data-vv-name="max_adminlms"-->
                    <!--                        data-vv-as="Jumlah Maksimal Admin LMS"-->
                    <!--                        v-validate="'required|numeric'"-->
                    <!--                        :error-messages="errors.collect('form.max_adminlms')"-->
                    <!--                      ></v-text-field>-->
                    <!--                    </v-col>-->
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import format from "date-fns/format";
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      step: 1,
      editable: false,
      searchInput: "",
      duplicate: false,
      kelas: {},
      diklat: null,
      defMapel: {
        nama: "",
        tanggal_mulai: new Date().toISOString(),
        tanggal_selesai: new Date().toISOString(),
        max_peserta: 0,
        max_gp: 0,
        max_dosen: 0,
        max_fasilitator: 0,
        max_pendamping: 0,
        max_adminlms: 0,
        max_instruktur: 0,
        max_narasumber: 0
      },
      itemPengampus: [],
      itemKandidats: [],
      selectedItems: [],
      itemModas: ['Daring','Luring'],
      page: null,
      cp: 1,
      current_page: 0,
      jump_page: 0,
      selection: [],
      pagging: {},
      page_key: 0,
      totalPagination: [],
      headers: [{ text: "", align: "left", value: "foto" }, { text: "Nama", align: "left", value: "nama" }],
      itemTingkats: [],
      itemJenjangs: [],
      itemMapels: [],
      itemModuls: [],
      itemRombels: [],
      countMapelPilihan: 0,
      pilihanId: [],
      alert: ALERT_INFO,
      konfigPeran: []
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.step = 1;
      this.diklat = { ...this.current_diklat };
      this.loadJenjang();
      this.loadJenisDiklat();
      this.loadMapel();

      this.kelas = obj
        ? {
            ...obj,
            ...(this.editable = true)
          }
        : {
            ...this.defMapel,
            ...(this.editable = false)
          };

      if (obj) {
        this.kelas.tanggal_mulai = new Date(obj.tanggal_mulai).toISOString();
        this.kelas.tanggal_selesai = new Date(obj.tanggal_selesai).toISOString();
      } else {
        this.countMapelPilihan = 0;
      }
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    validasiStep(e) {
      this.$validator.validateAll("form").then(res => {
        if (!res) return;
        this.step = e;
        return this.e;
      });
    },

    loadMapel(jenjang_id) {
      return this.$store
        .dispatch("mapel/getAll", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          params: {
            jenjang_id: jenjang_id
          }
        })
        .then(res => {
          this.itemMapels = res;
        })
        .catch(e => e);
    },
    filterPeran(val) {
      const peranFiltered = val.filter(v => v.max_attribute);
      return peranFiltered;
    },
    loadJenisDiklat() {
      return this.$store
        .dispatch("diklat/konfigurasiPeran", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          jenis_diklat_id: this.current_diklat.jenis_diklat_id
        })
        .then(res => {
          this.konfigPeran = res;
        })
        .catch(e => e);
    },

    loadJenjang() {
      return this.$store
        .dispatch("kelas/jenjang", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          params: {}
        })
        .then(res => {
          this.itemJenjangs = res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.kelas.grup_kelas_id = this.$route.params.grup_id ? this.$route.params.grup_id : null;
          this.kelas.tanggal_mulai = format(this.kelas.tanggal_mulai, "YYYY-MM-DD HH:mm:ss");
          this.kelas.tanggal_selesai = format(this.kelas.tanggal_selesai, "YYYY-MM-DD HH:mm:ss");
          return this.$store
            .dispatch("kelas/form", {
              instansi_id: this.instansi_id,
              diklat_id: this.diklat_id,
              obj: this.kelas
            })
            .then(res => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  },
  watch: {
    searchInput(val) {
      if (!val) {
        return;
      }
      this.loadPengampu();
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
